import { dateTimeTypePolicy } from "./scalar-types";

export const scalarTypePolicies = {
  Beneficiary: {
    fields: { createdAt: dateTimeTypePolicy, terminatedAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  BeneficiaryDelivery: {
    fields: { approvedAt: dateTimeTypePolicy, receivedAt: dateTimeTypePolicy, stagedAt: dateTimeTypePolicy },
  },
  BeneficiaryTransactionSet: { fields: { receivedAt: dateTimeTypePolicy } },
  CaseRecommendation: { fields: { generatedAt: dateTimeTypePolicy } },
  CaseRoom: { fields: { openedAt: dateTimeTypePolicy, snapshotAt: dateTimeTypePolicy } },
  CaseRoomTurn: { fields: { finishedAt: dateTimeTypePolicy, startedAt: dateTimeTypePolicy } },
  ExecutionResultArtifact: { fields: { createdAt: dateTimeTypePolicy } },
  InsuranceCheckStatus: { fields: { lastAnsweredAt: dateTimeTypePolicy, lastAttemptAt: dateTimeTypePolicy } },
  InsuranceMembership: { fields: { confirmedAt: dateTimeTypePolicy } },
  NateraIntakeActivation: { fields: { reminderAt: dateTimeTypePolicy } },
  OpenCaseRequirement: { fields: { since: dateTimeTypePolicy } },
  Partner: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PartnerGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ResourceSnapshotResult: { fields: { computedAt: dateTimeTypePolicy } },
  RpaForecastEntry: { fields: { dispatchAt: dateTimeTypePolicy } },
  RpaLinkView: { fields: { createdAt: dateTimeTypePolicy, lastSessionAt: dateTimeTypePolicy } },
  RpaSessionDot: { fields: { startedAt: dateTimeTypePolicy } },
  SatisfiedCaseRequirement: { fields: { since: dateTimeTypePolicy } },
  UnattestedCaseRequirement: { fields: { since: dateTimeTypePolicy } },
  UserHealthRecord: { fields: { updatedAt: dateTimeTypePolicy } },
  UserUploadedDocumentsResult: { fields: { createdAt: dateTimeTypePolicy } },
  WebAgentExecutionResult: { fields: { createdAt: dateTimeTypePolicy } },
};
